module.exports = __webpack_public_path__ + "js/7.dc8fb50e.worker.js"